$(function() {
  $('[name="purpose"]').change(function() {//name=""の中には、ラジオボタンのnameをいれます
    $(".is_hide").hide();
    if (($("select[name='purpose']").val() == "お初参りのお申込み") || ($("select[name='purpose']").val() == "七五三のお申込み") || ($("select[name='purpose']").val() == "成人式のお申込み") || ($("select[name='purpose']").val() == "結婚式のお申込み")) {
        $('.is_hide').show();
    }
  }).trigger('change');
});
